import axiosInstance from './axios-instance';

export type NotificationFilter = 'all' | 'mentions' | 'assignments';

export interface NotificationUserSummary {
  id: number;
  firstName?: string;
  lastName?: string;
  label?: string;
}

export interface NotificationItem {
  id: number;
  type: string;
  title: string;
  message?: string | null;
  metadata?: Record<string, any>;
  isRead: boolean;
  readAt?: string | null;
  isResolved: boolean;
  resolvedAt?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  notebookId?: number | null;
  projectId?: number | null;
  orderId?: number | null;
  clientId?: number | null;
  originator?: NotificationUserSummary | null;
  resolvedBy?: NotificationUserSummary | null;
}

export interface NotificationsListResponse {
  items: NotificationItem[];
  total: number;
  unreadCount: number;
  mentionUnresolvedCount?: number;
  mentionResolvedCount?: number;
  limit: number;
  offset: number;
}

export const getNotifications = async (payload: {
  filter: NotificationFilter;
  hideResolvedMentions?: boolean;
  limit?: number;
  offset?: number;
}) => {
  const res = await axiosInstance.post<NotificationsListResponse>('/notebook/notifications/list', payload);
  return res.data;
};

export const getUnreadNotificationsCount = async () => {
  const res = await axiosInstance.post<{ unreadCount: number }>(
    '/notebook/notifications/unread-count',
    {}
  );
  return res.data;
};

export const markNotificationsRead = async (payload: { id?: number; ids?: number[]; isRead?: boolean }) => {
  const res = await axiosInstance.patch('/notebook/notifications/mark-read', payload);
  return res.data;
};

export const resolveNotification = async (payload: { id: number; resolved: boolean }) => {
  const res = await axiosInstance.patch('/notebook/notifications/resolve', payload);
  return res.data;
};

export const resolveAllMentionNotifications = async (payload: { resolved: boolean }) => {
  const res = await axiosInstance.patch('/notebook/notifications/resolve-all-mentions', payload);
  return res.data;
};

export const deleteNotification = async (id: number) => {
  const res = await axiosInstance.delete(`/notebook/notifications/${id}`);
  return res.data;
};

export const createNotification = async (payload: any) => {
  const res = await axiosInstance.post('/notebook/notifications/create', payload);
  return res.data;
};
